import { CthEntryScreen } from '@/screens/completeTheHand/CthEntryScreen'

export default function () {
  return <CthEntryScreen />
}
